const empty = (data) => {
    // Handle Date objects - they should not be considered empty
    if (data instanceof Date) {
        return false;
    }
    if (typeof (data) === 'number' || typeof (data) === 'boolean') {
        return false;
    }
    if (typeof (data) === 'undefined' || data === null) {
        return true;
    }
    if (typeof (data.length) !== 'undefined') {
        return data.length === 0;
    }
    for (let i in data) {
        if (Object.prototype.hasOwnProperty.call(data, i)) {
            return false;
        }
    }
    return true;
};

const roundOffPaymentAmount = (amount) => {
    if (empty(amount)) return 0;
    if (typeof amount !== 'number') {
        amount = parseFloat(amount);
    }
    if (isNaN(amount)) return 0;
    return Math.round(amount);
}

export const utils = {
    empty,
    roundOffPaymentAmount
}

export default {
    empty,
    roundOffPaymentAmount
}